import { useEffect, useState } from 'react'

type FlagsResponse = {
  aiChatbot: boolean
}

let flagsPromise: Promise<FlagsResponse> | null = null

const fetchFlags = (): Promise<FlagsResponse> => {
  if (!flagsPromise) {
    flagsPromise = fetch('/api/flags')
      .then((res) => (res.ok ? res.json() : { aiChatbot: false }))
      .catch(() => ({ aiChatbot: false }))
  }
  return flagsPromise
}

export const isDesignStudioChatBotEnabled = async () => {
  const flags = await fetchFlags()
  return flags.aiChatbot
}

export const useAIChatbotEnabled = () => {
  const [enabled, setEnabled] = useState(false)

  useEffect(() => {
    let cancelled = false
    isDesignStudioChatBotEnabled()
      .then((value) => {
        if (!cancelled) setEnabled(value)
      })
      .catch(() => {
        if (!cancelled) setEnabled(false)
      })
    return () => {
      cancelled = true
    }
  }, [])

  return enabled
}

const isLocalhost = () => {
  return window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
}

const isMobile = () => {
  return window.innerWidth < 768
}

const hasLocalStorageFlag = () => {
  return localStorage.getItem('design-studio-debug-enabled') === 'true'
}

export const isDebugPanelEnabled = async () => {
  return !isMobile() && (isLocalhost() || hasLocalStorageFlag())
}
